import React from 'react';
import AbstractModalView from 'common/components/AbstractModalView';
import styles from './styles.module.scss';
import CloseButton from 'common/assets/close_button.svg';
import StepHandler from '../StepHandler';
import FormForgotPassword from './FormForgotPassword';
import FormForgotPasswordReset from './FormForgotPasswordReset';
import FormForgotPasswordSetNew from './FormForgotPasswordSetNew';

const ModalForgotPassword = () => (
  <AbstractModalView
    subPath={'forgot-password'}
    modalContainerClassName={styles.modal}
    triggerContent={({openModal}) => (
      <>
        <div
          className={styles.buttonForgotPassword}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            openModal();
          }}>
          סיסמה
        </div>
      </>
    )}
    modalContent={({closeModal}) => (
      <>
        <div className={styles.modalHeaderContainer}>
          <img
            src={CloseButton}
            alt="close-btn"
            onClick={closeModal}
          />
        </div>
          <StepHandler
            steps={[
              FormForgotPassword,
              FormForgotPasswordReset,
              FormForgotPasswordSetNew,
            ]}
            payload={{closeModal}}
          />
      </>
    )}
  />
);

export default ModalForgotPassword;
